import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';

export const useAlertStore = defineStore({
  id: 'alert',
  state: () => ({
    loader: {},
    alerts: [],
  }),
  actions: {
    async initAlerts() {
      this.loader = { loading: true };
      fetchWrapper
        .get('/studentapp/api/alerts')
        .then((alerts) => (this.alerts = alerts))
        .catch((error) => (this.loader = { error }));
    },
  },
});
